import { Store, GetterTree, MutationTree, ActionTree, Module } from "vuex";

import { RootState } from "@/store";
import container from "@/inversify.config";
import EnquiryService from "@/services/enquiry.service";
import { ICreativeEnquiryState } from "@/store/states/creative-enquiry-state";
import { ICreativeEnquirySummary } from "@/models/interfaces/enquiry/creative-enquiry-summary.model.interface";
import { ICreativeOverview } from "@/models/interfaces/overview/creative-overview.model.interface";
import { CreativeEnquirySummary } from "@/models/enquiry/creative-enquiry-summary.model";

export const state: ICreativeEnquiryState = {
  enquiryPerformance: []
};

export const getters: GetterTree<ICreativeEnquiryState, RootState> = {
  enquiryPerformance(state) {
    return state.enquiryPerformance;
  },
  creativeEnquiriesLoaded(state) {
    return state.enquiryPerformance.filter((a) => a.templateId !== null).length > 0;
  },
  creativeOverview(state, getters, rootState) {
    const result: ICreativeOverview[] = [];

    rootState.propertyPerformanceModule.templatePerformance.forEach((p) => {
        let enquiry = state.enquiryPerformance.filter((a) => a.templateId === p.id)[0];

        if (!enquiry) {
            enquiry = new CreativeEnquirySummary(p.id);
        }

        result.push({
            performance: p,
            enquiry
        });
    });

    return result;
  },
};

export const mutations: MutationTree<ICreativeEnquiryState> = {
  creativeEnquiryPerformance(state, data: ICreativeEnquirySummary[]) {
    if (data) {
      state.enquiryPerformance = data;
    } else {
        state.enquiryPerformance = [];
    }
  }
};

export const actions: ActionTree<ICreativeEnquiryState, RootState> = {
  async retrieveCreativeEnquiryPerformance({ commit, rootState, rootGetters }, propertyId: number) {
    return new Promise((resolve, reject) => {
      if (rootGetters["userModule/revenueAccess"]) {
      container.get<EnquiryService>(EnquiryService)
        .getCreativeEnquiries(
          propertyId,
          rootState.userSelectionModule.dateFrom,
          rootState.userSelectionModule.dateTo)
        .then((value) => {
          if (!rootGetters["userModule/isAdmin"] && value.result) {
            value.result.forEach((element) => {
              if (propertyId === 19 || propertyId === 20) {
                element.revenue = element.revenue * 0.30;
              } else {
                element.revenue = element.revenue * 0.25;
              }
            });
          }
          commit("creativeEnquiryPerformance", value.result);
          resolve(true);
        });
      } else {
        resolve(true);
      }
    });
  }
};

export const creativeEnquiryModule: Module<ICreativeEnquiryState, RootState> = {
  state, getters, mutations, actions, namespaced: true
};
